import axios from "axios";
import { get, post } from "@/http/index.js";
import { USER, REGISTER, MEETING, MEMBER } from "@/utils/http.js";
// import {memberURL} from "../../../mms-cloud-admin/src/request/host";

/**
 * 全部字典
 */
export const getDictionary = () => get(MEETING + "/dictionary/items");

/**
 * 会员类型
 */
export const getDuesList = params => post(MEMBER + "/dues/single", params);
//团体会员类型及会费标准
export const getGroupDues = params =>
  post(MEMBER + "/dues/group", params);
/**
 * 分会/总会
 */
export const getBranchs = () => post(MEMBER + "/branch/branches");

/**
 * 职称
 */
export const getZhiCheng = params =>
  get(MEMBER + "/dictionary/TITLE", params, true);

export const getDictionaryByCode = params =>
    get(MEETING + "/dictionary/" + params);
/**
 * 地址
 */
export const getDivisionData = params => get(USER + "/district", params);

/**
 * 用户信息
 */
export const getUser = params => get(MEMBER + "/account/current");

//当前登录用户
export const getCurrentAccount = params => get(MEMBER + "/account/current", params);

//全部会议
export const getMeetingAll = (params, page) =>
    post(MEETING + "/page/" + page, {});
//未开始会议
export const getNotstarted = (params, page) =>
    post(MEETING + "/notstarted/" + page, {});
//已结束会议
export const getFinished = (params, page) =>
    post(MEETING + "/finished/" + page, {});
//获取地址
export const getAddress = params => get(MEETING + "/district");
//缴费凭证图片
export const getPZUrl = params => get(MEMBER + "/file/display/base64", params);
//获取用户信息
export const getAssociationCurrent = params =>
    post(MEMBER + "/association/current");

//已报名会议
export const registeredMeeting = (params, page) => post(MEETING + "/register/page/" + page, params, true);
//未缴费列表
export const getMeetingPaymentList = (params, page) => post(MEETING + "/order/page/" + page, params);
// 获取会议注册设定
export const getMeetingSettings = params => get(MEETING + "/register/setting", params, true);
// 获取会议注册默认表单值
export const getRegisterForm = params =>  post(MEETING + "/register/form", params);
// 会议报名
export const registerMeeting = params => post(MEETING + "/register", params, true);
// 会议报名时根据姓名和手机号查询用户信息
export const getUserInfoByNameMobile = params => post(MEETING + "/register/findUser", params, true);
//会议报名时的用户快速注册
export const registerUser = params => post(MEMBER + "/register/userAndMember", params, true);
//会议宾馆
export const getHotels = params => post(MEETING + "/hotel/hotels", params, true);
//宾馆信息保存
export const hotelSave = params => post(MEETING + "/hotel/booking", params, true);
//宾馆取消
export const hotelCancel = params =>
  post(MEETING + "/hotel/booking/cancel", params, true);
//base64
export const getBase64 = params => get(MEETING + "/file/display/base64", params, true);
// 获取已报名会议
export const getRegisterList = params => post(MEETING + "/register/list", params);
//创建会议订单
export const createMeetingOrder = params => post(MEETING + "/order/create", params || {});
//正在报名的会议
export const getStartingMeeting = (params, page) =>
    post(MEETING + "/starting/" + page, {});
//域名
export const baseURL = axios.defaults.baseURL;

//缴费历史记录
export const getPaymentList = (params, page) =>
  post(MEMBER + "/order/page/" + page, params);
//取消记录
export const paymentCancel = params => post(MEMBER + "/order/cancel", params);
//取消订单
export const cancelMeetingOrder = params =>
  post(MEETING + "/order/cancel", params || {});


//会员缴费审核
export const memberAudit = params =>
  post(MEMBER + "/admin/order/audit", params);
//是否显示缴纳会费按钮
export const isShowPayBtn = params =>
  post(MEMBER + "/order/create/check", params);
//创建订单
export const createOrder = params => post(MEMBER + "/order/create", params);
//支付宝支付
export const getAliCode = params => post("/alipay/membership/pay", params);
//微信支付-会员
export const getWXCode = params => post(MEMBER + "/wxpay/pay", params);
//微信支付-链接
export const getAuthurl = params => post(MEMBER + "/wxpay/getAuthurl", params);
//微信支付-链接
export const getOpenid = params => post(MEMBER + "/wxpay/getOpenid", params);

//订单详情
export const getOrderDetails = params => get(MEMBER + "/order/details", params);
//微信支付-会议
export const getMeetingWXCode = params => post(MEETING + "/wxpay/pay", params);
//是否支持微信支付-会员
export const getWXPay = params => post(MEMBER + "/config/wxpay/enable", params);
//是否支持微信支付-会议
export const getMeetingWXPay = params =>
  post(MEETING + "/config/wxpay/enable", params);
//线下提交
export const underLineSubmit = params => post(MEMBER + "/offline/pay",params);
export const underLineSubmitMeeting = params => post(MEETING + "/offline/pay",params);
//支付SockJS-会员
export const SockJSURL = MEMBER + "/websocket";
//支付SockJS-会议
export const SockJSMeetingURL = MEETING + "/websocket";

//退出
export const logout = params => post(USER + "/oauth/logout", params);

//会议详情
export const getMeetingDetail = params =>
  post(MEETING + "/details", params, true);
//获取上次登录信息
export const getLastLoginTime = params =>
  post(MEMBER + "/account/user", params);

// 获取会议会场
export const getMeetingPlaces = params =>
    post(MEETING + "/place/places", params, true);


/**
 * 站内信
 */
//获取站内信消息
export const queryMail = (params, page) =>
  post(MEMBER + "/info/queryMail/" + page, params);
//删除站内信消息
export const delMessageReceiver = (params) =>
  post(MEMBER + "/info/delMessageReceiver", params);
//保存收件信息
export const saveReceiver = (params) =>
    post(MEMBER + "/info/saveReceiver", params);
//站内信已读条数
export const unRead = (memberId) =>
    get(MEMBER + "/info/unRead",memberId);
//站内信详情
export const findInfoById = (params) =>
    get(MEMBER + "/info/findInfoById",params);
//站内信详情
export const findFileById = (params) =>
    get(MEMBER + "/file/findFileById",params);
//检查站内信是否有未插入消息
export const getCheckMessage = params =>
    get(MEMBER + "/info/checkMessageInfo",params,true);
//下载
export const downLoadFile = id => MEETING + "/file/download?id=" + id;
//会员风采列表
export const getMemberStyleList = (params, page) => get(MEMBER + "/admin/memberStyle/page/" + page, params);
//会员风采详情
export const MemberStyleDetails = params => get(MEMBER + "/admin/memberStyle/details", params);
//会员风采保存
export const saveMemberStyle = params => post(MEMBER + "/admin/memberStyle/save", params);
//获取批处理字段详细
export const getSchemaDetails = params => post(MEMBER + "/schema/details", params, true);